const enum LocalStorageKeyEnum {
  popupDismissedDate = 'POPUP_DISMISSED_DATE',
}

export default LocalStorageKeyEnum;
